// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2yPbu","navText":"Navbar_navText__1TuY3","navLogo":"Navbar_navLogo__1V6xX","imgLogo":"Navbar_imgLogo__26bVj"};